/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import Main from '../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import CustomTable from '../../../components/common/CustomTable';
import TableAction from '../../../components/TableAction';
import { approveJobs, bulkDeleteJobs, clearJobsData, fetchJobs, selectJobsData, selectJobsMeta, setJobsData, setJobsMeta } from '../../../store/slices/api/inner/jobsSlice';
import { selectSelectedJobs, setSelectedJobs, toggleCommonDeleteModal } from '../../../store/slices/common';
import Checkbox from '../../../components/common/Checkbox';
import Button from '../../../components/common/Button';
import { LuChevronLeft, LuChevronRight, LuChevronsLeft, LuChevronsRight } from 'react-icons/lu';
import JobDetailModal from './JobDetailModal';
import axios from 'axios';

export const PendingJobs = () => {
  const jobsData = useSelector(selectJobsData);
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(false);
  const jobsMeta = useSelector(selectJobsMeta);
  const selectedJobs = useSelector(selectSelectedJobs);
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  const dispatch = useDispatch();

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchJobs,
    setValueAction: setJobsData,
    setMeta: setJobsMeta,
    clearValueActionOnError: clearJobsData,
    isForm: false,
    successMessage: false,
  });

  const openDeleteModal = (data) => {
    data && dispatch(setSelectedJobs(data));
    dispatch(toggleCommonDeleteModal());
  };

  const cancelDeleteModal = () => {
    dispatch(setSelectedJobs(null));
    dispatch(toggleCommonDeleteModal());
  };

  const handleDetail = async (data) => {
    setLoading(true);
    setModalOpen(true);
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/jobs/${data?.job_id}`, {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        });
        if (response?.data?.status === 'success') {
          setJobData(response?.data?.job);
        }
      } catch (err) {
        console.log(err);
      }
      finally {
        setLoading(false);
      }
    }
    // dispatch(setSelectedJobs(data));
    // navigate(NAVIGATION.INNER_NAVIGATION.JOBS.JOBS_DETAIL, { state: { jobsData: data } });
  };

  useEffect(() => {
    fetchData({ page: currentPage, limit: pageSize,job_status:"Pending" });
  }, [currentPage, pageSize]);

  const handleCheckboxChange = (jobId) => {
    setSelectedJobIds((prevSelected) =>
      prevSelected.includes(jobId)
        ? prevSelected.filter((id) => id !== jobId)
        : [...prevSelected, jobId]
    );
  };

  const handleSelectAll = () => {
    setSelectAll((prevSelectAll) => !prevSelectAll);
    setSelectedJobIds(selectAll ? [] : jobsData?.map((job) => job.job_id));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const columns = useMemo(() => [
    {
      id: 'selection',
      cell: info => (
        <Checkbox
          checked={selectedJobIds.includes(info.row.original.job_id)}
          onChange={() => handleCheckboxChange(info.row.original.job_id)}
        />
      ),
      header: () => (
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAll}
        />
      ),
    },
    {
      accessorKey: 'job_title',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header: 'Job Title',
    },
    {
      accessorKey: 'inferred_country',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header: 'Inferred Country',
    },
    {
      accessorKey: 'job_type',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header: 'Job Type',
    },
    {
      accessorKey: 'company_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header: 'Company Name',
    },
    {
      accessorKey: 'job_status',
      cell: info => (
        <span
          onClick={() => handleSubmit({ jobIds: [info.row.original.job_id] })}
          className={`${info.getValue() === 'pending' ? 'cursor-pointer text-yellow-800 border-yellow-400 bg-yellow-100' : 'text-green-800 border-green-400 bg-green-100'} text-xs font-medium me-2 px-2.5 py-0.5 rounded border`}
        >
          {info.getValue()}
        </span>
      ),
      filterFn: 'includesStringSensitive',
      header: 'Job Status',
    },
    {
      id: 'actions',
      cell: info => (
        <TableAction
          handleDetailButton={() => handleDetail(info?.row?.original)}
          handleDeleteButton={() => openDeleteModal(info?.row?.original)}
        />
      ),
      header: () => <span>Actions</span>,
    },
  ], [handleCheckboxChange, fetchData]);

  const afterApproveOrDeleteAPICall = (response, isDelete) => {
    fetchData({ page: currentPage, limit: pageSize, job_status: "Pending" });
    setSelectedJobIds([]);
    isDelete && dispatch(toggleCommonDeleteModal());
    isDelete && dispatch(setSelectedJobs(null));
  };

  const { handleSubmit } = useApiRequest({
    apiAction: approveJobs,
    clearForm: false,
    afterAPICall: afterApproveOrDeleteAPICall,
    isForm: false,
  });

  const { handleSubmit: handleBulkDelete } = useApiRequest({
    apiAction: bulkDeleteJobs,
    isForm: false,
    afterAPICall: (res) => { afterApproveOrDeleteAPICall(res, true) },
  });

  return (
    <Main
      crumbs={[{ title: "Jobs" }]}
      handleDelete={() => handleBulkDelete({ jobIds: selectedJobIds && selectedJobIds.length !== 0 ? selectedJobIds : [selectedJobs?.job_id] })}
      handleCandleDelete={cancelDeleteModal}
    >
      <CustomTable
        columns={columns}
        data={jobsData}
        isApiPagination={true}
        tableTop={selectedJobIds && selectedJobIds.length !== 0 && (
          <div className='flex gap-3'>
            <Button size="small" onClick={() => handleSubmit({ jobIds: selectedJobIds })}>Approve</Button>
            <Button size="small" onClick={openDeleteModal}>Delete</Button>
          </div>
        )}
        pageSize={pageSize}
      />

      <div className="flex items-center justify-between flex-col gap-2 mt-3 md:flex-row">
        <div className='flex items-center'>
          <button
            className="border rounded p-2"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <LuChevronsLeft />
          </button>
          <button
            className="border rounded p-2"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <LuChevronLeft />
          </button>
          <button
            className="border rounded p-2"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === jobsMeta?.totalPages}
          >
            <LuChevronRight />
          </button>
          <button
            className="border rounded p-2"
            onClick={() => handlePageChange(jobsMeta?.totalPages)}
            disabled={currentPage === jobsMeta?.totalPages}
          >
            <LuChevronsRight />
          </button>
        </div>
        <span className="flex items-center gap-1">
          <div>Page</div>
          <strong>
            {currentPage} of {jobsMeta?.totalPages || 1}
          </strong>
        </span>
        <div className='flex items-center gap-2'>
          <span className="flex items-center gap-1">
            Go to page:
            <input
              type="number"
              value={currentPage}
              min={1}
              max={jobsMeta?.totalPages || 1}
              className="'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-2.5"
              onChange={(e) => {
                const page = Number(e.target.value);
                if (page >= 1 && page <= (jobsMeta?.totalPages || 1)) {
                  handlePageChange(page);
                }
              }}
            />
          </span>
          <select
            value={pageSize}
            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
          >
            {[100, 200, 300, 400, 500].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
      </div>

      <JobDetailModal isOpen={isModalOpen} onClose={() => { setModalOpen(false); setJobData(null); }} loading={loading} jobsData={jobData} />

    </Main>
  );
};
